import { getString } from "../../common/common";


export const ABOUT_US = "ABOUT_US";
export const HISTORY = "HISTORY";
export const MI_BUS_SERVICES = "MI_BUS_SERVICES";
export const MI_KEY_STATISTICS = "MI_KEY_STATISTICS";
export const MI_LABOUR_WELFARE = "MI_LABOUR_WELFARE";
export const MI_PROCUREMENT = "MI_PROCUREMENT";
export const MI_PASSENGER_SAFETY = "MI_PASSENGER_SAFETY";
export const MI_INFRA_FACILITY = "MI_INFRA_FACILITY";
export const MI_ANNUAL_REPORT = "MI_ANNUAL_REPORT";

export const MI_LETTER_CIRCULARS = "MI_LETTER_CIRCULARS";
export const MI_LUGGAGE_RATES = "MI_LUGGAGE_RATES";
export const MI_RES_TERMS = "MI_RES_TERMS";
export const MI_GUEST_USER_TERMS = "MI_GUEST_USER_TERMS";
export const MI_REFUND_RULES = "MI_REFUND_RULES";
export const MI_BOOKING_COUNTERS = "MI_BOOKING_COUNTERS";
export const MI_PASSESS_CONCESSION = "MI_PASSESS_CONCESSION";

export const MI_NEWS_EVENTS = "MI_NEWS_EVENTS";
export const MI_TENDER = "MI_TENDER";
export const MI_RECRUITMENT = "MI_RECRUITMENT";
export const MI_CAREERS = "MI_CAREERS";
export const MI_SENIORITY_LIST = "MI_SENIORITY_LIST";

export const MI_KSRTC_FRANCHISEE = "MI_KSRTC_FRANCHISEE";


export const translations = {
  en: {
    [ABOUT_US]: "About Us",
    [HISTORY]: "History",
    [MI_BUS_SERVICES]: "Bus Services",
    [MI_KEY_STATISTICS]: "Key Statistics",
    [MI_LABOUR_WELFARE]: "Labour Welfare",
    [MI_PROCUREMENT]: "Procurement",
    [MI_PASSENGER_SAFETY]: "Passenger Safety",
    [MI_INFRA_FACILITY]: "Infrastructure & Facility",
    [MI_ANNUAL_REPORT]: "Annual Administration Report",

    [MI_LETTER_CIRCULARS]: "Letters & Circulars",
    [MI_LUGGAGE_RATES]: "Luggage Rates",
    [MI_RES_TERMS]: "Reservation Terms",
    [MI_GUEST_USER_TERMS]: "Guest Users Terms",
    [MI_REFUND_RULES]: "Refund Rules and Claims",
    [MI_BOOKING_COUNTERS]: "Booking Counters",
    [MI_PASSESS_CONCESSION]: "Passes & Concession",

    [MI_NEWS_EVENTS]: "News and Events",
    [MI_TENDER]: "Tender",
    [MI_RECRUITMENT]: "Recruitment",
    [MI_CAREERS]: "Careers",
    [MI_SENIORITY_LIST]: "Seniority List",

    [MI_KSRTC_FRANCHISEE]: "Become a KSRTC Franchisee",
  },
  kn: {
    [ABOUT_US]: "ನಮ್ಮ ಬಗ್ಗೆ",
    [HISTORY]: "ಇತಿಹಾಸ",
    [MI_BUS_SERVICES]: "ಬಸ್ ಸೇವೆಗಳು",
    [MI_KEY_STATISTICS]: "ಪ್ರಮುಖ ಅಂಕಿಅಂಶಗಳು",
    [MI_LABOUR_WELFARE]: "ಕಾರ್ಮಿಕ ಕಲ್ಯಾಣ",
    [MI_PROCUREMENT]: "ಸಂಗ್ರಹಣೆ",
    [MI_PASSENGER_SAFETY]: "ಪ್ರಯಾಣಿಕರ ಸುರಕ್ಷತೆ",
    [MI_INFRA_FACILITY]: "ವಾರ್ಷಿಕ ಆಡಳಿತ ವರದಿ",
    [MI_ANNUAL_REPORT]: "ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ಸೌಲಭ್ಯ",

    [MI_LETTER_CIRCULARS]: "ಪತ್ರಗಳು ಮತ್ತು ಸುತ್ತೋಲೆಗಳು",
    [MI_LUGGAGE_RATES]: "ಲಗೇಜ್ ದರಗಳು",
    [MI_RES_TERMS]: "ರಿಸೆರ್ವೆಷನ್ ನಿಯಮಗಳು",
    [MI_GUEST_USER_TERMS]: "ಅತಿಥಿ ಬಳಕೆದಾರರ ನಿಯಮಗಳು",
    [MI_REFUND_RULES]: "ಮರುಪಾವತಿ ನಿಯಮಗಳು ಮತ್ತು ಹಕ್ಕುಗಳು",
    [MI_BOOKING_COUNTERS]: "ಬುಕಿಂಗ್ ಕೌಂಟರ್‌ಗಳು",
    [MI_PASSESS_CONCESSION]: "ಪಾಸ್‌ಗಳು ಮತ್ತು ರಿಯಾಯಿತಿ",

    [MI_NEWS_EVENTS]: "ಸುದ್ದಿ ಮತ್ತು ಘಟನೆಗಳು",
    [MI_TENDER]: "ಟೆಂಡರ್",
    [MI_RECRUITMENT]: "ನೇಮಕಾತಿ",
    [MI_CAREERS]: "ವೃತ್ತಿಗಳು",
    [MI_SENIORITY_LIST]: "ಸೀನಿಯಾರಿಟಿ ಲಿಸ್ಟ್",

    [MI_KSRTC_FRANCHISEE]: "ಕ.ರಾ.ರ.ಸಾ.ನಿ ದ ವ್ಯವಹಾರ ವಿತರಕರಾಗಿ",

  },
};

export const tFooterCommon = (key = "") => {
  return getString(key, translations);
};
